import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { OperatoriService } from '../operatori.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { finalize, map, tap } from 'rxjs';
import { Generic } from 'src/app/interfaces/generic.interface';
import { Observable, Subject } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';

@Component({
    selector: 'app-update-functie-operator',
    templateUrl: './update-functie-operator.component.html',
    styleUrls: ['./update-functie-operator.component.scss']
})
export class UpdateFunctieOperatorComponent implements OnInit {
    private unsubscribe$ = new Subject<void>();

    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    successIcon: string = environment.config.customNotifications.icons.success;

    defaultParameter: { name: string; id: string } = {
        name: '--Alegeți--',
        id: '-1',
    };

    functiiOperator$!: Observable<Generic[]>;

    isLoading = true;

    form: FormGroup = new FormGroup({
        functie_id: new FormControl('-1', [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<UpdateFunctieOperatorComponent>,
        private notificationService: NotificationService,
        private authService: AuthService,
        private operatorService: OperatoriService,
        private commonService: CommonService,
    ) {
        this.loadFunctii()
        this.loadFunctieOperator();
    }

    ngOnInit(): void {
    }

    loadFunctii() {
        this.isLoading = true;
        this.functiiOperator$ = this.commonService.getFunctii()
            .pipe(
                map((results: any) => results),
                finalize(() => (this.isLoading = false))
            );
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        console.log('not implemented yet');
    }

    loadFunctieOperator() {
        this.isLoading = true;
        this.operatorService
            .getOperatorFunctie(this.data.id_user)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (results: any) => {
                    this.form.patchValue({
                        functie_id: results.data.user_functie_id
                    })
                    console.log(results, 'check form')
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            })
    }

    updateFunctieOperator() {
        this.isLoading = true;
        this.operatorService
            .updateOperatorFunctie(this.data.id_user, this.form.value)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.success,
                        'Actualizare cu succes',
                        this.successIcon
                    );
                    this.closeDialog();
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
